import { gql } from "@apollo/client";

import { TUTOR_AWARD_CERTIFICATE_FIELDS } from "../queries/tutorAwardCertificates";

export const CREATE_TUTOR_AWARD_CERTIFICATE = gql`
  mutation CreateTutorAwardCertificate(
    $input: UpdateTutorAwardCertificateInput!
  ) {
    createCertTutorAwardCertificate(input: $input) {
      ...TutorAwardCertificateFields
    }
  }
  ${TUTOR_AWARD_CERTIFICATE_FIELDS}
`;

export const UPDATE_TUTOR_AWARD_CERTIFICATE = gql`
  mutation UpdateTutorAwardCertificate(
    $id: ID!
    $input: UpdateTutorAwardCertificateInput!
  ) {
    updateCertTutorAwardCertificate(id: $id, input: $input) {
      ...TutorAwardCertificateFields
    }
  }
  ${TUTOR_AWARD_CERTIFICATE_FIELDS}
`;

export const DELETE_TUTOR_AWARD_CERTIFICATE = gql`
  mutation DeleteTutorAwardCertificate($id: ID!) {
    deleteCertTutorAwardCertificate(id: $id) {
      id
    }
  }
`;
